import React, { useState } from 'react';
import Dropzone from 'react-dropzone';
import styles from './add-image-modal.module.scss';
import CloseIcon from '@mui/icons-material/Close';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { WBox, WModal, WTypography } from '../../wrappers/wrapper';
import Button from 'components/atoms/button/button';

interface IUploadImage {
  links: boolean;
  onClose: () => any;
  onImageUpload: (file: File) => any;
}

export default function UploadImage({ onClose, onImageUpload }: IUploadImage) {
  return (
    <React.Fragment>
      <WModal
        open={true}
        onClose={onClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <WBox>
          <div className={styles['attachModal']}>
            <div className={styles['head']}>
              <div className={styles['top']}>
                <WTypography variant="h5" className={styles['text']}>
                  Attach Images
                </WTypography>
                <div onClick={onClose} className={styles.closeButton}>
                  <CloseIcon fontSize="small" />
                </div>
              </div>
            </div>
            <Dropzone
              multiple={false}
              onDrop={(acceptedFiles) => {
                onClose();
                onImageUpload(acceptedFiles[0]);
              }}
            >
              {({ getRootProps, getInputProps }) => (
                <WBox className={styles['content']}>
                  <div className={styles['upload-container']} {...getRootProps()}>
                    <input {...getInputProps()} />

                    <div className={styles['upload-content']}>
                      <CloudUploadIcon fontSize="large" />
                      <div>
                        <p className={styles.title}>Drop your image here to upload</p>
                        <span>Works with any .JPG, .PNG, or .GIF file from the web</span>
                      </div>
                      <Button type={'primary'} radius="2rem" onClick={() => {}}>
                        Choose File
                      </Button>
                    </div>
                  </div>
                </WBox>
              )}
            </Dropzone>
          </div>
        </WBox>
      </WModal>
    </React.Fragment>
  );
}
